<template>
  <div>
    <vx-card class="mb-5" title="A day in the life ">
      <p class="mb-5">Video here</p>
    </vx-card>

    <vx-card>
      <h4 class="mb-5">Coding vs programming</h4>
      <p class="mb-5">
        Although you might think they're more or less the same thing, programming and coding are two
        different terms for a software developer. There is some debate around the difference, but
        generally programming is about developing a fully formed software, whereas coding is just
        taking part in the process of programming. That means every element of coding is a part of
        programming.
      </p>

      <h5 class="mb-5">Programming languages</h5>

      <p class="mb-5">
        If you think you’d like to become a programmer, then you need to get familiar with
        programming languages like C++, Java, Python or JavaScript. You can choose any to learn, but
        It is expected that software developers will know at least one programming language.
      </p>
      <p class="mb-5">
        Most will know more than one to cover all bases - this means they will appeal more to
        prospective employers when they apply for jobs. Here’s some of the most widely used ones
        today that are very useful to know:
      </p>
      <centered-image-wrapper
        :image="image1"
        classes="2/3"
        alt="Top 10 popular programming languages in 2020: 1 Python, 2 JavaScript, 3 Java, 4 C#, 5 C, 6 C++, 7 GO, 8 R, 9 Swift, 10 PHP. Source: northeastern.edu/graduate."
      />

      <h5 class="mb-5">Data Structures & Algorithms</h5>
      <p class="mb-5">
        A data structure is a particular way of organising and storing data in a computer so that it
        can be used effectively. Data structures and algorithms form the backbone of computer
        science. An algorithm refers to a set of specific steps to solve a problem.
      </p>
      <p class="mb-5">
        Learning the common algorithms and data structures will help you solve problems more
        efficiently. Data structures can be quite complex, but there are lots of courses and there
        is plenty of accessible information online - learning these skills is a process and you
        might not know programming languages straight away.
      </p>
      <centered-image-wrapper :image="image2" classes="2/3" alt="" />

      <h5 class="mb-5">Problem solving</h5>
      <p class="mb-5">
        Problem solving means defining a problem, determining the cause of the problem, and
        implementing a solution. Computer Programmers are problem solvers. In order to solve a
        problem on a computer you must:
      </p>
      <ol class="numbered-list">
        <li>Know how to represent the information (data) describing the problem.</li>
        <li>
          Determine the steps to transform the information from one representation into another.
        </li>
      </ol>
      <centered-image-wrapper
        :image="image3"
        classes="2/3"
        alt="Problem Solving Chart: a circle divided into four quarters joined by arrows in a cycle: Define the problem, Generate new ideas, Evaluate and select solutions, Implement and evaluate."
      />

      <h5 class="mb-5">Software development planning process</h5>
      <p class="mb-5">
        In software development, every piece of software goes through a similar path from idea to
        launch day and every great piece of software starts with a plan and a clear process in
        place. Luckily, there are lots of software development processes you can choose from.
      </p>
      <h5 class="mb-5">The Waterfall software development process</h5>
      <p class="mb-5">
        The Waterfall software development process (also known as the “linear sequential model” or
        “Classic lifecycle model”) is one of the oldest and most traditional models for building
        software.
      </p>
      <p class="mb-5">
        In its most basic form, you can think of the Waterfall method as following each step in
        sequence - meaning you have to finish each one in order before moving on. The phases are:
      </p>

      <ol class="numbered-list">
        <li>Planning</li>
        <li>Requirements</li>
        <li>System and software design</li>
        <li>Implementation</li>
        <li>Testing</li>
        <li>Deployment</li>
        <li>Maintenance/Updates</li>
      </ol>

      <h5 class="mb-5">Agile</h5>
      <p class="mb-5">
        Agile is a relatively new project management process that is becoming very popular. Agile
        helps teams with collaboration and working in small increments. Requirements, plans, and
        results are evaluated continuously so teams can respond to change quickly.
      </p>
      <p class="mb-5">
        As opposed to the Waterfall process’ strict, sequential flow, in Agile, cross-functional
        teams work in “Sprints” of 2 weeks to 2 months to build and release usable software to
        customers for feedback.
      </p>
      <p class="mb-5">
        Agile is all about moving fast, releasing often, and responding to the real needs of your
        users, even if it goes against what’s in your initial plan
      </p>
      <centered-image-wrapper
        :image="image4"
        classes="2/3"
        alt="Waterfall model versus Agile. Both list the same seven phases: Conception, Initiation, Analysis, Design, Construction, Testing, Deployment. In the Waterfall model, arrows run straight down from each phase to the next in a single sequence. In Agile, the phases are connected by looping arrows so the team cycles back through earlier phases repeatedly. Illustrated by Segue Technologies."
      />
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      videoURL: false,
      showVideoPopupFile: false,
      showVideoPopupYt: false,
      ytVideoUrl: false,
      image1: require('@/assets/images/experiences/developer/lr1.png'),
      image2: require('@/assets/images/experiences/developer/lr2.png'),
      image3: require('@/assets/images/experiences/developer/lr3.png'),
      image4: require('@/assets/images/experiences/developer/lr4.png'),
    };
  },
  provide: function () {
    return {
      closePopup: this.closePopup,
    };
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
